export default {
    barColor: 'rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)',
    barImage: '',
    drawer: null,

    /**
     * Active manager
     * left or right
     * default: left
     */
    activeManager: 'left',

    /**
     * Clipboard
     * Operation type - copy || cut
     */
    clipboard: {
        type: null,
        disk: null,
        directories: [],
        files: [],
    },

    // available disks
    disks: [],

    // file callback for ckeditor, ...
    fileCallback: null,

    // full screen mode
    fullScreen: false,
 
}
